import { render, staticRenderFns } from "./StockByDistributor.vue?vue&type=template&id=62e5d87f&scoped=true&"
import script from "./StockByDistributor.vue?vue&type=script&lang=js&"
export * from "./StockByDistributor.vue?vue&type=script&lang=js&"
import style0 from "./StockByDistributor.vue?vue&type=style&index=0&id=62e5d87f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e5d87f",
  null
  
)

export default component.exports